import declarationEGTB from '@/content/pdf/Declaration-Aqad_EGTB_MY.pdf';
import declarationEGIB from '@/content/pdf/Declaration_EGIB_MY.pdf';
import importantNoticeEGIB from '@/content/pdf/Important-Notice_EGIB_MY.pdf';
import importantNoticeEGTB from '@/content/pdf/Important-Notice_EGTB_MY.pdf';
import pdsHohhAgencyEGIB from '@/content/pdf/PMG_EGIB_HOHH_PDS_AGENCY_BM.pdf';
import pdsHohhBancaEGIB from '@/content/pdf/PMG_EGIB_HOHH_PDS_BANCA_BM.pdf';
import policyHohhAgencyEGIB from '@/content/pdf/PMG_EGIB_HOHH_PW_AGENCY_BM.pdf';
import policyHohhBancaEGIB from '@/content/pdf/PMG_EGIB_HOHH_PW_BANCA_BM.pdf';
import pdsMyRumahAgencyEGIB from '@/content/pdf/PMG_EGIB_MYRUMAH_PDS_AGENCY_BM.pdf';
import policyMyRumahAgencyEGIB from '@/content/pdf/PMG_EGIB_MYRUMAH_PW_AGENCY_BM.pdf';
import policyHohhAgencyEGTB from '@/content/pdf/PMG_EGTB_HOHH_CW_AGENCY_BM.pdf';
import policyHohhBancaEGTB from '@/content/pdf/PMG_EGTB_HOHH_CW_BANCA_BM.pdf';
import pdsHohhAgencyEGTB from '@/content/pdf/PMG_EGTB_HOHH_PDS_AGENCY_BM.pdf';
import pdsHohhBancaEGTB from '@/content/pdf/PMG_EGTB_HOHH_PDS_BANCA_BM.pdf';
import policyMyRumahAgencyEGTB from '@/content/pdf/PMG_EGTB_MYRUMAH_CW_AGENCY_BM.pdf';
import pdsMyRumahAgencyEGTB from '@/content/pdf/PMG_EGTB_MYRUMAH_PDS_AGENCY_BM.pdf';
import privacyNoticeEGIB from '@/content/pdf/Privacy-Notice_EGIB_MY.pdf';
import privacyNoticeEGTB from '@/content/pdf/Privacy-Notice_EGTB_MY.pdf';
import pdsHohhEGTB from '@/content/pdf/PMG_EGTB_HOHH_PDS_BM_2605V0.2.pdf';

export default {
  declaration_insurance: declarationEGIB,
  declaration_takaful: declarationEGTB,
  importantNotice_insurance: importantNoticeEGIB,
  importantNotice_takaful: importantNoticeEGTB,
  privacyNotice_insurance: privacyNoticeEGIB,
  privacyNotice_takaful: privacyNoticeEGTB,
  pds: {
    hohh: {
      Direct_insurance: 'https://eti.qa/go/hohh-pds-bm',
      Direct_takaful: pdsHohhEGTB,
      Indirect_insurance: pdsHohhAgencyEGIB,
      Indirect_takaful: pdsHohhAgencyEGTB,
      Agent_insurance: pdsHohhAgencyEGIB,
      Agent_takaful: pdsHohhAgencyEGTB,
      Banca_insurance: pdsHohhBancaEGIB,
      Banca_takaful: pdsHohhBancaEGTB,
    },
    myrumah: {
      Direct_insurance: 'https://eti.qa/go/myrumah-pds-bm',
      Direct_takaful: 'https://eti.qa/go/myrumah-tak-pds-bm',
      Indirect_insurance: pdsMyRumahAgencyEGIB,
      Indirect_takaful: pdsMyRumahAgencyEGTB,
      Agent_insurance: pdsMyRumahAgencyEGIB,
      Agent_takaful: pdsMyRumahAgencyEGTB,
      Banca_insurance: pdsMyRumahAgencyEGIB,
      Banca_takaful: pdsMyRumahAgencyEGTB,
    },
  },
  policyContract: {
    hohh: {
      Direct_insurance: 'https://eti.qa/go/hohh-polisi',
      Direct_takaful: 'https://eti.qa/go/hohh-sijil',
      Indirect_insurance: policyHohhAgencyEGIB,
      Indirect_takaful: policyHohhAgencyEGTB,
      Agent_insurance: policyHohhAgencyEGIB,
      Agent_takaful: policyHohhAgencyEGTB,
      Banca_insurance: policyHohhBancaEGIB,
      Banca_takaful: policyHohhBancaEGTB,
    },
    myrumah: {
      Direct_insurance: 'https://eti.qa/go/myrumah-polisi',
      Direct_takaful: 'https://eti.qa/go/myrumah-sijil',
      Indirect_insurance: policyMyRumahAgencyEGIB,
      Indirect_takaful: policyMyRumahAgencyEGTB,
      Agent_insurance: policyMyRumahAgencyEGIB,
      Agent_takaful: policyMyRumahAgencyEGTB,
      Banca_insurance: policyMyRumahAgencyEGIB,
      Banca_takaful: policyMyRumahAgencyEGTB,
    },
  },
};
